export type ShapeKind = 'rectangle' | 'ellipse' | 'triangle'

export interface ShapeKindDef {
  readonly id: ShapeKind
  readonly label: string
  readonly requiredPoints: 2 | 3
}

export const SHAPE_KINDS: readonly ShapeKindDef[] = [
  { id: 'rectangle', label: 'Rectangle', requiredPoints: 2 },
  { id: 'ellipse', label: 'Circle', requiredPoints: 2 },
  { id: 'triangle', label: 'Triangle', requiredPoints: 3 },
] as const

export const DEFAULT_SHAPE_KIND: ShapeKindDef = SHAPE_KINDS[0]
